<template>
    <div
        :class="this.creatorStudio.settings.prompt_modifier.includes(prompt) ? 'prompt-selected' : 'prompt'"
        @click="addPrompt"
    >
        <span>{{ prompt }}</span>
    </div>
</template>
<script>
import PromptEditorManager from '../../../manager/PromptEditorManager';
import store from '../../../mixins/store.mixin';
export default {
    name: 'AddPrompt',
    props: { prompt: String },
    data() {
        return {};
    },
    mixins: [store],
    computed: {},
    methods: {
        addPrompt() {
            PromptEditorManager.addPrompt(this.prompt);
        },
    },
};
</script>
<style lang="scss">
.prompt {
    box-sizing: border-box;
    min-height: 39px;
    border: 3px solid #595959;
    border-radius: 9px;
    padding: 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
    &:hover {
        background: #323232;
    }
}
.prompt-selected {
    background-color: #1266f1;
    box-sizing: border-box;
    min-height: 39px;
    border: 3px solid #1266f1;
    border-radius: 9px;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    cursor: pointer;
}
</style>
